import { CSSProperties } from 'react';
import * as DataTableTypes from './DataTableTypes';

export function getAlignStyle(align: DataTableTypes.ColumnAlignment | undefined): CSSProperties {
  if (!align) return {};
  return { justifyContent: align === 'center' ? 'center' : 'right' };
}

export function getEllipsisOnOverflow(ellipsisOnOverflow: boolean | undefined, isSticky: boolean): boolean {
  // if isSticky is true check if ellipsisOnOverflow was explicitly set to true, if not then set it to false
  if (isSticky) return ellipsisOnOverflow ?? false;
  return ellipsisOnOverflow || ellipsisOnOverflow === undefined;
}

export function getStickyStyles(isSticky: boolean): CSSProperties {
  return isSticky ? { justifyContent: 'flex-end', zIndex: 5 } : {};
}

// TODO: Remove after column sizing is implemented
export const CELL_MIN_WIDTH = 65;
export const CELL_MIN_WIDTH_WITH_COLUMN_SIZING = 160;

export const defaultColumnStyling: CSSProperties = {
  // TODO: Remove after column sizing is implemented
  flex: '65 0 auto',
  minWidth: CELL_MIN_WIDTH, // minWidth is only used as a limit for resizing
  boxSizing: 'border-box'
};
